import { lazy } from 'react';
import { useSelector } from 'react-redux';

import GameDrawer from '@ezugi/bootstrap/src/views/GameDrawer';

import { isBackAndLaySelector } from '../../store/selectors/game';
import {
  GAME_BOARD_PERCENTAGE_HEIGHT as BACK_AND_LAY_GAME_BOARD_PERCENTAGE_HEIGHT,
  lightBoxBgColor,
} from '../../views/GameBoard/BackAndLay/style';
import { GAME_BOARD_PERCENTAGE_HEIGHT as DEFAULT_GAME_BOARD_PERCENTAGE_HEIGHT } from '../../views/GameBoard/style';
import { toggleContainerStyle } from './GameRightSideDrawer.css';
import RightSideDrawerToggler from './RightSideDrawerToggler';

const RightSideDrawerContent = lazy(() => import('../RightSideDrawerContent'));
const RightSideDrawerContentBackAndLay = lazy(
  () => import('../RightSideDrawerContent/BackAndLay')
);

function GameRightSideDrawer() {
  const isBackAndLay = useSelector(isBackAndLaySelector);
  const GAME_BOARD_PERCENTAGE_HEIGHT = isBackAndLay
    ? BACK_AND_LAY_GAME_BOARD_PERCENTAGE_HEIGHT
    : DEFAULT_GAME_BOARD_PERCENTAGE_HEIGHT;

  return (
    <GameDrawer
      align="right"
      toggler={RightSideDrawerToggler}
      togglerContainerClassName={toggleContainerStyle[isBackAndLay ? 'bl' : 'default']}
      style={{ height: '50%', top: `-${GAME_BOARD_PERCENTAGE_HEIGHT / 2}%` }}
      panelStyle={isBackAndLay ? lightBoxBgColor : undefined}
      hideOnGameOpen={isBackAndLay}
    >
      {isBackAndLay ? (
        <RightSideDrawerContentBackAndLay />
      ) : (
        <RightSideDrawerContent />
      )}
    </GameDrawer>
  );
}

export default GameRightSideDrawer;
